import { useWindowScroll, watchDebounced } from '@vueuse/core'
import { ref } from 'vue'

export function useScrollValue() {
  const { y } = useWindowScroll()
  const isScrolled = ref(false)
  const scrollingToTop = ref(false)
  const dirtyScroll = ref(false)

  watchDebounced(
    y,
    (newY, oldY) => {
      isScrolled.value = newY > 0
      scrollingToTop.value = newY < oldY
      dirtyScroll.value = true
    },
    { debounce: 20, flush: 'post', maxWait: 5000 },
  )

  return {
    dirtyScroll,
    isScrolled,
    scrollingToTop,
    y,
  }
}
